import { type PropsWithChildren, useEffect, useState } from "react";

type SwitchableProps = PropsWithChildren<{
  defaultExpanded?: boolean;
  title?: string;
  togglerProps?: any;
  icon?: any;
  collapseThreshold?: number | false;
}>;

const SwitchableCustom: React.FC<SwitchableProps> = ({
  children,
  defaultExpanded = true,
  title,
  togglerProps,
  icon,
  collapseThreshold = false,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [userAction, setUserAction] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (!userAction && collapseThreshold !== false && window.innerWidth <= collapseThreshold) {
        setIsExpanded(false);
      }
      else {
        setIsExpanded(true)
      }
    };

    if (!userAction && collapseThreshold !== false) {
      window.addEventListener("resize", handleResize);
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [collapseThreshold, userAction]);

  const handleToggle = () => {
    setUserAction(true);
    setIsExpanded((prev) => !prev);
  };

  return (
    <view
      data-name="switchable"
      data-switchable-type="custom"
      data-direction="row"
      data-align="start"
      data-border="none"
      data-expanded={isExpanded}
      {...rest}
    >




      <view data-scroll="" data-border="no" data-name="switch_content"
      //data-length="fit"
      >
        {children}
      </view>
      <group
        data-height="fit"
        //data-length="0"
        data-position="right"
        data-name="custom_switch_wrap"
        data-border=""
      >
        <group

          //data-position="absolute"
          data-align="start"
          data-width="auto"
          data-top="20"
          data-right="15"
        >
          <group
            data-name="switch"
            data-wrap="no"
            data-index="2"
            //data-interactive=""
            data-cursor="pointer"
            data-align="center"
            data-gap="5"
            data-border=""
            data-radius="30"
            data-background="main-background"
            onClick={handleToggle}
            {...togglerProps}
          >
            <group data-index="1" data-width="auto" data-background="main-background" data-border="" data-radius="30" className={isExpanded ? "open" : ""}>
              {icon ?? "apps"}
            </group>
            {title && (
              <>
                <text data-index="1" data-weight="500" data-space="5">
                  {title}
                </text>
              </>
            )}
          </group>
        </group>
      </group>

    </view>
  );
};

export default SwitchableCustom;
